export function checkCookies(): boolean {
  try {
    return !!navigator.cookieEnabled;
  } catch (error) {
    return false;
  }
}
